module.exports = __webpack_public_path__ + "img/IUCN-RedList.96bf9d18.png";